import { render } from "./DefRemove.vue?vue&type=template&id=16c7486a&scoped=true"
const script = {}

import "./DefRemove.vue?vue&type=style&index=0&id=16c7486a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c7486a"]])

export default __exports__